import BreakingDealsContainerMobile from '../../../../components/containers/BreakingDealsContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadBreakingDealsProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'breaking-deals--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  containerConfig: {
    settings: {
      instance: BreakingDealsContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
